// extracted by mini-css-extract-plugin
export default {"container":"Estimates_container__5kAhm","title":"Estimates_title__T6Xrl","list":"Estimates_list__Y09f0","item":"Estimates_item__5Ry9D"};